import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {API_URLS} from "../../app-config/api.url.config";
import {Person} from "../models/person.model";
import {TrackrespModel} from "../models/trackresp.model";

@Injectable({
  providedIn: 'root'
})
export class TrackService {

  constructor(private httpClient: HttpClient) { }

  track(person: Person): Observable<TrackrespModel> {
    const url = API_URLS.API_URLS_PASSPORT_TRACK;
    return this.httpClient.post<TrackrespModel>(url, person);
  }

  track_(person: Person): Observable<TrackrespModel> {
    const mock: TrackrespModel = {
      data: {
        cid: '123',
        booking: 'BK001',
        birthDay: '2000-01-01',
        lastName: 'Smith',
        available: false,
        withdrawn: true
      },
      status: 'OK',
      errorCode: 0,
      message: 'Success'
    };

    return of(mock);
  }
}
